import { trapFocus, removeTrapFocus } from './global'; // eslint-disable-line

class QuickSearch extends HTMLElement {
  constructor() {
    super();

    this.quicksearch = document.getElementsByTagName('quick-search')[0];
    this.header = document.querySelector('#shopify-section-header');
    this.noResult = this.quicksearch.querySelector('.quicksearch-content').getAttribute('data-no-result');
    this.searchURL = this.quicksearch.querySelector('.quicksearch-content').getAttribute('data-search-url');

    let searchTimer;
    document.querySelector('#shopify-section-header').addEventListener('keyup', (e) => {
      if (e.target.classList.contains('search-field') || e.target.classList.contains('search__input')) {
        // disable search button first to allow Boost request to finish
        this.header.querySelector('.search-modal__form').setAttribute('onsubmit', 'return false;');
        this.quicksearch.querySelector('.search-modal__form').setAttribute('onsubmit', 'return false;');

        if (e.code === 'Escape') {
          this.close();
        } else {
          // revert mobile & desktop search form submission URL to default, replacing redirect URL
          this.header.querySelector('.search-modal__form').setAttribute('action', this.searchURL);
          this.quicksearch.querySelector('.search-modal__form').setAttribute('action', this.searchURL);

          clearTimeout(searchTimer);
          searchTimer = setTimeout(() => {
            const searchValue = e.target.value;
            this.header.querySelector('.search-field').value = searchValue;
            this.header.querySelectorAll('.search__input')[0].value = searchValue;
            //  this.header.querySelectorAll('.search__input')[1].value = searchValue;
            this.openSearch('');
            if (searchValue !== '' && searchValue.length > 1) {
              // has result
              this.quicksearch.querySelector('.quicksearch-content').classList.add('loading');
              this.quicksearch.querySelector('.quicksearch-content').setAttribute('has-content', true);
              this.searchSuggest(searchValue);
            } else {
              // no result
              this.quicksearch.querySelector('.quicksearch-content').classList.remove('loading');
              this.quicksearch.querySelector('.quicksearch-content').setAttribute('has-content', false);
            }
          }, 600);
        }
      }
    });

    this.header.addEventListener('click', (e) => {
      if (e.target.classList.contains('header__icon--search')) {
        this.openSearch('focus');
        e.preventDefault();
      }
    });

    this.quicksearch.addEventListener('click', (e) => {
      if (e.target.dataset.action === 'close') {
        this.close();
        e.preventDefault();
      }
    });
  }

  openSearch(focusSearch) {
    document.body.classList.add('search-open');
    this.quicksearch.addEventListener('transitionend', () => {
      if (focusSearch === 'focus') {
        this.quicksearch.querySelector('.search-field').focus();
      }
      trapFocus(this.quicksearch);
    }, { once: true });

    let triggerDefaultSearchValue = true;
    const searchInputs = document.getElementsByName('q');
    searchInputs.forEach((input) => {
      if (input.value !== '') triggerDefaultSearchValue = false;
    });

    if (triggerDefaultSearchValue && window.outerWidth < 990) {
      this.searchSuggest(this.dataset.defaultSearchValue);
    }
  }

  close() {
    document.body.classList.remove('search-open');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  createSearchSuggestions(data) {
    if (data.suggestions.length > 0) {
      this.quicksearch.querySelector('#suggestions .suggestions').innerHTML = '';
      Object.entries(data.suggestions).forEach((entry) => {
        const [key, value] = entry;
        const encodedValue = encodeURI(`${value}`);
        this.quicksearch.querySelector('#suggestions .suggestions').insertAdjacentHTML('beforeend', `<div><a href="/search/?q=${encodedValue}">${value}</a></div>`);
      });
    } else {
      this.quicksearch.querySelector('#suggestions .suggestions').innerHTML = this.noResult;
    }
  }

  createSearchCollections(data) {
    if (data.collections.length > 0) {
      this.quicksearch.querySelector('#category .suggestions').innerHTML = '';
      Object.entries(data.collections).forEach((entry) => {
        const [key, value] = entry;
        this.quicksearch.querySelector('#category .suggestions').insertAdjacentHTML('beforeend', `<div><a href="/collections/${value.handle}">${value.title}</a></div>`);
      });
    } else {
      this.quicksearch.querySelector('#category .suggestions').innerHTML = this.noResult;
    }
  }

  createSearchPages(data) {
    if (data.pages.length > 0) {
      this.quicksearch.querySelector('#pages .suggestions').innerHTML = '';
      Object.entries(data.pages).forEach((entry) => {
        const [key, value] = entry;
        this.quicksearch.querySelector('#pages .suggestions').insertAdjacentHTML('beforeend', `<div><a href="${value.url}">${value.title}</a></div>`);
      });
    } else {
      this.quicksearch.querySelector('#pages .suggestions').innerHTML = this.noResult;
    }
  }

  createSearchProducts(data) {
    if (data.total_product > 0) {
      this.quicksearch.querySelector('.column.products').setAttribute('has-product', true);
      this.quicksearch.querySelector('.product-list').innerHTML = '';

      const resultCurrency = this.quicksearch.querySelector('.quicksearch-content').getAttribute('data-currency-symbol');

      Object.entries(data.products).forEach((entry) => {
        const [key, value] = entry;
        const { metafields, title } = value;

        let metaStyle = '';
        let metaMaterial = '';
        let metaColor = '';

        metafields.forEach((element, index) => {
          if (element.namespace === 'birkenstock') {
            switch (element.key) {
              case 'style':
                metaStyle = element.value;
                break;
              case 'material':
                metaMaterial = element.value;
                break;
              case 'colourvalue':
                metaColor = element.value;
                break;
              default:
            }
          }
        });

        let itemFormattedTitle = `${metaStyle}${metaMaterial}${metaColor}`;
        if (itemFormattedTitle !== '') {
          if (metaMaterial === '') {
            const trimmedTitle = value.title.replace(metaStyle, '');

            itemFormattedTitle = `<big>${metaStyle}</big> <span>${trimmedTitle}</span>`;
          } else {
            itemFormattedTitle = `<big>${metaStyle}</big> <span>${metaMaterial}</span> <span>${metaColor}</span>`;
          }
        } else {
          itemFormattedTitle = value.title;
        }

        let imgHTML = '';
        if (value.images_info[0] !== undefined) {
          const imageSRC = value.images_info[0].src.replace('.jpg?', '_318x.jpg?').replace('.png?', '_318x.png?');
          imgHTML = `<img src="${imageSRC}" loading="lazy" width="317" height="317" />`;
        }

        const onSale = value.compare_at_price_min && (value.compare_at_price_min > value.price_min);
        const priceVaries = value.price_max !== value.price_min;

        let productPrice = `<span>${resultCurrency}${value.price_min.toFixed(2)}</span>`;
        if (onSale) {
          productPrice = `<span>${resultCurrency}${value.price_min.toFixed(2)}</span> <s>${resultCurrency}${value.compare_at_price_min.toFixed(2)}</s>`;
        } else if (value.product_type === 'Gift Cards' || priceVaries) {
          productPrice = `<span>From ${resultCurrency}${value.price_min.toFixed(2)}</span>`;
        }

        let badgeHTML = '';
        if (value.tags) {
          value.tags.forEach((tag) => {
            if (tag.indexOf('pfs:label') !== -1) {
              badgeHTML += `<span class="product-label__item product-badge-${tag.split('pfs:label-')[1].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}">${tag.split('pfs:label-')[1]}</span>`;
            }
          });
        }
        const itemHTML = `<div class="search-card">
                        <a href="/products/${value.handle}" class="search-link">
                          <div class="product-badge-wrapper flex flex-wrap">${badgeHTML}</div>
                          <span class="image-box">
                            ${imgHTML}
                          </span>
                          <strong class="title">
                            ${itemFormattedTitle}
                          </strong>
                          <em class="price">
                            ${productPrice} 
                          </em>
                        </a>  
                      </div>`;

        this.quicksearch.querySelector('.product-list').insertAdjacentHTML('beforeend', itemHTML);
      });
    } else {
      this.quicksearch.querySelector('.column.products').setAttribute('has-product', false);
    }
  }

  createNoResults(data) {
    if (data.products.length == 0 && data.pages.length == 0 && data.collections.length == 0 && data.suggestions.length == 0) {
      this.quicksearch.querySelector('.quicksearch-content').setAttribute('has-content', false);
    } else {
      this.quicksearch.querySelector('.quicksearch-content').setAttribute('has-content', true);
    }
  }

  createSearchRedirect(data) {
    const resultCount = this.quicksearch.querySelector('.quicksearch-content').getAttribute('data-result');
    const resultCountView = this.quicksearch.querySelector('.quicksearch-content').getAttribute('data-view-all');
    const resultCountViewAllProducts = this.quicksearch.querySelector('.quicksearch-content').getAttribute('data-view-all-products');
    if (data.redirect) {
      // update mobile & desktop form submission URL to what's configured from Boost search settings
      this.header.querySelector('.search-modal__form').setAttribute('action', data.redirect);
      this.quicksearch.querySelector('.search-modal__form').setAttribute('action', data.redirect);
      this.header.querySelector('#empty-search-result-with-redirect').removeAttribute('hidden');
      this.quicksearch.querySelector('.result-title').innerHTML = resultCount.replace('[count]', '');
      this.quicksearch.querySelector('.result-action').innerHTML = resultCountView.replace('[count]', '');
      this.quicksearch.querySelector('.result-action').setAttribute('href', data.redirect);
      this.quicksearch.querySelector('#quicksearch-bottom-link').innerHTML = resultCountView.replace('[count]', data.query);
      this.quicksearch.querySelector('#quicksearch-bottom-link').setAttribute('href', data.redirect);
    } else {
      this.header.querySelector('#empty-search-result-with-redirect').setAttribute('hidden', true);
      this.quicksearch.querySelector('.result-title').innerHTML = resultCount.replace('[count]', data.total_product);
      this.quicksearch.querySelector('.result-action').innerHTML = resultCountView.replace('[count]', data.total_product);
      this.quicksearch.querySelector('.result-action').setAttribute('href', `/search?q=${data.query}`);
      this.quicksearch.querySelector('#quicksearch-bottom-link').innerHTML = resultCountViewAllProducts;
      this.quicksearch.querySelector('#quicksearch-bottom-link').setAttribute('href', '/collections/all');
    }

    // enable search button after Boost has responded
    this.header.querySelector('.search-modal__form').removeAttribute('onsubmit');
    this.quicksearch.querySelector('.search-modal__form').removeAttribute('onsubmit');
  }

  searchSuggest(searchValue) {
    const searchTerm = encodeURI(searchValue.toLowerCase());
    const suggestionLimit = boostPFSAppConfig.settings.search.suggestionBlocks[0].number;
    const collectionLimit = boostPFSAppConfig.settings.search.suggestionBlocks[1].number;
    const productLimit = boostPFSAppConfig.settings.search.suggestionBlocks[2].number;
    const pageLimit = boostPFSAppConfig.settings.search.suggestionBlocks[3].number;
    const avalability = boostPFSAppConfig.settings.search.productAvailable;
    const milliseconds = (new Date()).getTime();
    const searchURL = `https://services.mybcapps.com/bc-sf-filter/search/suggest?q=${searchTerm}&shop=${boostPFSAppConfig.shop.domain}&t=${milliseconds}&product_available=${avalability}&suggestion_limit=${suggestionLimit}&collection_limit=${collectionLimit}&product_limit=${productLimit}&page_limit=${pageLimit}&dym_limit=2&check_cache=false`;

    fetch(searchURL)
      .then((response) => response.json())
      .then((data) => {
        // suggestions
        this.createSearchSuggestions(data);

        // collections
        this.createSearchCollections(data);

        // pages
        this.createSearchPages(data);

        // products
        this.createSearchProducts(data);

        // totally no results found
        this.createNoResults(data);

        this.createSearchRedirect(data);

        this.quicksearch.querySelector('.quicksearch-content').classList.remove('loading');
      })
      .catch((err) => console.warn('Something went wrong.', err));
  }
}

customElements.define('quick-search', QuickSearch);
